import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds";
import { AccordionPanel } from "./Panel";
/**
* **Accordion** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Accordion) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=4037:6864)
*
* The Accordion displays items that expand to show more information when clicked or tapped.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/accordion)
*
* @example
* () => {
*  const [activeIndex, updateActive] = useState(-1);
*
*  return (
*    <Accordion aria-label="Accordion group for FAQs">
*      {items.map((item, index) => (
*        <AccordionItem key={`${index}-item`}>
*          <AccordionTitle
*            key={`${index}-title`}
*            onClick={e => {
*              e.preventDefault();
*              updateActive(index === activeIndex ? -1 : index);
*            }}
*            isExpanded={index === activeIndex}
*          >
*            {item.title}
*          </AccordionTitle>
*          <AccordionContent isExpanded={index === activeIndex}>{item.content}</AccordionContent>
*        </AccordionItem>
*      ))}
*    </Accordion>
*  );
*};
*
*/
export var Accordion = /*#__PURE__*/React.forwardRef(function Accordion(_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(AccordionPanel, Object.assign({
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Accordion
  }));
});